const NAME_SPACE = 'jbp-offering-switcher'

export const TRANSLATION_KEYS = {
  warningDialog: {
    title: `${NAME_SPACE}-warning-dialog-title`,
    text: `${NAME_SPACE}-warning-dialog-text`,
    ok: `${NAME_SPACE}-warning-dialog-ok`,
    cancel: `${NAME_SPACE}-warning-dialog-cancel`,
  },
}
